// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"338":"component---src-templates-error-page-tsx","532":"styles"}[chunkId] + "-" + {"338":"84a909a8d70c3435305b","532":"23aa9f26fc4ee9cda838"}[chunkId] + ".js";
};